var ContentServerAssetLoader = require('./contentServerAssetLoader');
var DummyAssetLoader = require('./dummyAssetLoader');

///////////////
//constructor//
///////////////
var AssetLoaderFactory = function () {};
module.exports = AssetLoaderFactory;

//////////
//static//
//////////
AssetLoaderFactory.getInstance = function(dataManager, config) {
    return AssetLoaderFactory._init(dataManager, config);
};

///////////
//private//
///////////
AssetLoaderFactory._init = function (dataManager, config) {
    if (config.type === 'ContentServer') {
        if (AssetLoaderFactory._isValidConfig(config)) {
            return new ContentServerAssetLoader(dataManager, config);
        } else {
            throw new Error('Configuration error: Invalid AssetLoader configuration.');
        }
    }
    if (config.type === 'Dummy') {
        return new DummyAssetLoader(dataManager, config);
    }
    throw new Error('Configuration error: Incorrect type of ColabDocStoreConfig. For now, only \'ContentServer\' or \'Dummy\' are supported.');
};

AssetLoaderFactory._isValidConfig = function(config) {
    return true;
};
